<div
  class="card full-width"
  [ngClass]="{
    hilite:
      section.code?.toUpperCase()?.includes('AMENDMENT') ||
      section.name.toLowerCase().includes('amendment') ||
      section.name.toLowerCase().includes('ammendment'),
  }"
>
  <div class="card-header">
    <div class="row d-flex align-items-center">
      <div class="col d-flex nowrap">
        <div class="d-flex align-items-center">
          <h4 class="border0">{{ section.number }}.</h4>
          <h4
            *ngIf="!editing"
            [ngClass]="{
              'section-name': !disabled,
              'section-name-nohover': disabled,
            }"
            (click)="!disabled ? (editing = true) : null"
          >
            {{ section.name }}
          </h4>
          <h4 *ngIf="editing && !disabled" class="input-sizer stacked">
            <textarea
              aria-label="text"
              matInput
              onmouseover="this.parentNode.dataset.value = this.value"
              onfocus="this.parentNode.dataset.value = this.value"
              oninput="this.parentNode.dataset.value = this.value"
              rows="1"
              (change)="editing = false"
              [(ngModel)]="section.name"
              appTextareaAutoresize
              style="overflow: hidden; height: 100%"
            ></textarea>
          </h4>
        </div>
      </div>
      <div class="col d-flex align-items-center small"></div>
      <div class="col d-flex justify-content-end align-items-center">
        <tags-chips
          [value]="section.code"
          [disabled]="disabled"
          (valueChange)="section.code = $event"
        ></tags-chips>
        <div class="card-header-pills d-flex" *ngIf="!editing && !disabled">
          <button
            mat-icon-button
            class="mx-2"
            #trigger="matMenuTrigger"
            [matMenuTriggerFor]="settings"
            *ngIf="!disabled"
          >
            <mat-icon class="gray">settings</mat-icon>
          </button>
          <mat-menu class="no-padding-menu" #settings="matMenu">
            <div class="card">
              <div
                class="card-header"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <span class="card-title">Section Settings</span>
              </div>

              <div
                class="card-body"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <mat-form-field appearance="outline">
                  <mat-label>Section Tag</mat-label>
                  <input
                    matInput
                    uppercase
                    [(ngModel)]="section.code"
                    [disabled]="!!disabled"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  />
                </mat-form-field>
              </div>
              <div class="card-footer">
                <div mat-dialog-actions align="center">
                  <button mat-flat-button class="blue">Close</button>
                </div>
              </div>
            </div>
          </mat-menu>
          <button
            mat-icon-button
            *ngIf="section.number && !disabled"
            (click)="duplicate.emit(section)"
            matTooltip="Duplicate Section"
            color="primary"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
          <button
            mat-icon-button
            *ngIf="!disabled"
            (click)="delete.emit(section)"
            matTooltip="Delete Section"
            color="warn"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            *ngIf="!disabled"
            color="accent"
            (click)="steps.add()"
            matTooltip="Add Step"
          >
            <mat-icon>add_box</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body pb-3">
    <workflow-steps
      #steps
      [wfTableConfig]="wfTableConfig"
      [section]="section"
      [wfSectionID]="section.id"
      [disabled]="disabled"
      [sectionDropLists]="sectionDropLists"
      [stepDropLists]="stepDropLists"
    ></workflow-steps>
  </div>
</div>
